var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiStar = function SvgAiStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__a)",
    d: "M4.698 2.294c.233-.939 1.599-.939 1.832 0l.64 2.583c.084.335.351.597.694.678l2.643.627c.96.227.96 1.562 0 1.79l-2.643.626a.93.93 0 0 0-.694.679l-.64 2.583c-.233.938-1.6.938-1.832 0l-.641-2.583a.93.93 0 0 0-.694-.679L.72 7.972c-.96-.228-.96-1.563 0-1.79l2.643-.627a.93.93 0 0 0 .694-.678z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__b)",
    d: "M12.39 11.309c.144-.578.985-.578 1.128 0l.394 1.59a.57.57 0 0 0 .427.417l1.627.385a.564.564 0 0 1 0 1.102l-1.626.385a.57.57 0 0 0-.428.417l-.394 1.59c-.143.578-.984.578-1.127 0l-.394-1.59a.57.57 0 0 0-.427-.417l-1.627-.385a.564.564 0 0 1 0-1.102l1.627-.385a.57.57 0 0 0 .427-.418z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__c)",
    d: "M15.176 2.191c.094-.38.645-.38.74 0l.258 1.043a.38.38 0 0 0 .28.274l1.068.253a.37.37 0 0 1 0 .723l-1.068.253a.38.38 0 0 0-.28.274l-.259 1.043c-.094.379-.645.379-.74 0l-.258-1.043a.38.38 0 0 0-.28-.274l-1.068-.253a.37.37 0 0 1 0-.723l1.068-.253a.38.38 0 0 0 .28-.274z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__d)",
    fillRule: "evenodd",
    d: "m15.546 2.376-.212.851a.95.95 0 0 1-.704.689l-.871.206.87.207c.349.082.62.348.705.688l.212.852.21-.852a.95.95 0 0 1 .705-.688l.871-.207-.87-.206a.95.95 0 0 1-.705-.689zm.422-.46c-.107-.434-.738-.434-.845 0l-.296 1.191a.43.43 0 0 1-.32.313l-1.22.29a.423.423 0 0 0 0 .826l1.22.289a.43.43 0 0 1 .32.313l.296 1.192c.107.433.738.433.845 0l.296-1.192a.43.43 0 0 1 .32-.313l1.22-.29a.423.423 0 0 0 0-.826l-1.22-.289a.43.43 0 0 1-.32-.313z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__e)",
    d: "M5.182 18.473a.854.854 0 0 1-.864-.845c0-.466.387-.844.864-.844s.863.378.863.844a.854.854 0 0 1-.863.845"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__f)",
    d: "M.864 15.096A.854.854 0 0 1 0 14.252c0-.466.387-.844.864-.844s.863.378.863.844a.854.854 0 0 1-.863.844"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__g)",
    d: "M9.5.746c-.477 0 0 .466 0 0s-.354-.042.123-.042S9.5.28 9.5.746c.477 0 0 .466 0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-star_svg__h)",
    d: "M18.136 10.875a.854.854 0 0 1-.863-.844c0-.466.386-.844.863-.844s.864.378.864.844a.854.854 0 0 1-.864.844"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__a",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__b",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__c",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__d",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__e",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__f",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__g",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-star_svg__h",
    x1: 9.5,
    x2: 9.5,
    y1: -0.098,
    y2: 18.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD88CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9FB"
  })))));
};
export default SvgAiStar;